<div class="custom-alert">
  <div class="horizontal">
    <img class="image close" src="assets/images/header/close.svg" (click)="onClose()">
  </div>
  <div>
    <ng-container *ngFor="let v of data?.values">
      <div class="ta-c">
        <img *ngIf="v?.icon" class="image-header" src="{{v?.iconSrc}}">
      </div>
      <p [class]="v?.class" *ngIf="v?.type === 'p'">
        {{v?.value}}
      </p>

    </ng-container>
    <div class="{{data?.actions?.class}}" *ngIf="data?.actions?.buttons?.length">
      <div *ngFor="let button of data?.actions?.buttons">
        <app-mapfre-button
          *ngIf="button?.text"
          class="df mapfre-mt-sm"
          [fw]="ctx?.isTablet || ctx?.isDesktop ? 700 : 500"
          expand="block"
          (click)="button?.handler() || onClose()"
        >
          {{ button?.text | translate }}
        </app-mapfre-button>
      </div>
    </div>
  </div>
</div>
